import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi'
import { z } from 'zod'
import { AssigneeTypeEnum } from '@omnea-app/packages/universal/users-and-groups/assigneeType'

extendZodWithOpenApi(z)

export const AssigneeSchema = z
  .object({
    id: z.string(),
    value: z.string(),
    name: z.string().optional(),
    email: z.string().optional(),
    type: z.enum(AssigneeTypeEnum),
  })
  .openapi('Assignee')

export type AssigneeEntity = z.infer<typeof AssigneeSchema>
